import React from 'react';
export function StickyBuyButton() {
  return <div className="fixed bottom-0 left-0 w-full p-4 bg-gradient-to-t from-dark via-dark/90 to-transparent z-50 md:hidden" data-id="element-180">
      <a href="https://www.etsy.com/listing/4490149718/wedding-nfc-sign-tap-to-share-photos-qr" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full py-4 bg-gold text-dark font-semibold rounded-full shadow-[0_0_20px_rgba(201,168,76,0.4)] active:scale-95 transition-transform" data-id="element-181">
        👉 Buy Now
      </a>
    </div>;
}